export default __webpack_public_path__ + "static/media/svg.958426d7.png";